export default {
  test: '测试',
  tabel: {
    label: '中文'
  },
  homePage:'首页',
  jadeFountainHill:'玉泉山',
  guanLing:'关陵',
  recentNews:'最新动态',
  playGuide:'游玩攻略',
  smartTourism:'智慧旅游',
  forgame:'云游',
  oneClickReservation:'一键预定',
  oneKeyNavigation:'一键导航',
  messageInteraction:'留言互动',
  yuquanCulturalTravel:'玉泉文旅',
  companyProfile:'企业介绍',
  businessCooperation:'招商合作',
  talentWanted:'诚聘英才',
  contactUs:'联系我们',
  scenicSpotAddress:'景区地址',
  businessHours:'营业时间',
  Scenic_spot_dynamics:'景区动态',
  view_more:'查看更多',
  yysj_hint:'如有特殊安排，以现场开放为准',
  yqsgljj:'玉泉山关陵简介',
  Click_for_details:'点击查看详情',
  playspot:'玩转景区',
  jqjj_text:'玉泉山关陵景区是由湖北玉泉文化旅游开发有限公司投资开发，将玉泉山与关陵原本独立的两个景区资源整合，以关公文化为核心，通过一核两翼的形式，充分整合两个景区的优势资源，打造的以关公文化为核心，生态景观为依托，千年玉泉文化为基底的综合型休闲旅游度假区。',
  syyq_text:'诗意玉泉',
  scgf_text:'诗词歌赋',
  video:'视频',
  audio:'音频',
  mtj_text:'美图集',
  ykxz_text:'游客须知',
  complaints_hotline:'投诉电话',
  tiktok:'官方抖音',
  red_bok:'玉泉文旅',
  official_account:'官方公众号',
  micro_blog:'官方微博',
  gpfs_text:'联系我们',
  wwsb_text:'文物三宝',
  zwsb_text:'植物三宝',
  sjbj_text:'四绝八景',
  unfold:'展开',
  jqhd_text:'景区活动',
  jqgg_text:'景区公告',
  back_text:'返回',
  view_details:'查看详情',
  fbpl_text:'发表评论',
  unit_text:'联系单位',
  phone_text:'联系方式',
  recruiter:'招聘者',
  wechat:'微信',
  postbox:'邮箱',
  jbyq_text:'基本要求',
  xl_text:'学历',
  specialty:'专业',
  zwms_text:'职位描述',
  fldy_text:'福利待遇',
  yqs_dz:'玉泉山地址',
  yqs_address:'湖北省宜昌市当阳市玉泉山风景名胜区',
  gl_dz:'关陵地址',
  gl_address:'湖北省宜昌市当阳市关陵路关陵景区',
  jdxq_text:'景点详情',
  jqdt_text:'景区动态',
  jqhdxq_text:'景区活动详情',
  jqhdxq_title:'活动详情',
  close_text:'收起',
}



// WEBPACK FOOTER //
// ./src/lang/ch.js